<template functional>
  <section :class="['FormSect', data.class, data.staticClass]">
    <div v-if="props.title" class="title">
      <h3>{{ props.title }}</h3>
      <div v-if="props.sub" class="sub">
        {{ props.sub }}
      </div>
      <slot name="titleSide" />
    </div>
    <slot />
  </section>
</template>

<script>
export default {
  props: {
    sub: String,
    title: String,
  },
}
</script>

<style lang="scss">
section.FormSect {
  border-bottom: 1px solid $border-color;
  padding: $grid-unit 0;

  > .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: $grid-unit;

    h3 {
      color: $text-color-mid;
      margin-bottom: 0;
    }

    .sub {
      color: $grey;
      font-size: $h5;
      line-height: 1rem;
    }
  }

  p {
    margin: $grid-unit 0;
  }
}
</style>
